import React from 'react';
import { useTranslation } from 'react-i18next';
import { palette } from '@m12s/component-library';
import PropTypes from 'prop-types';
import BaseModal from 'components/BaseModal';
import { ModalButton } from 'components/BaseModal/styled';

const FAISubmitWorkPromptModal = ({
  isOpen,
  onClose,
  onSkip,
  onSendForInspection,
  sendLoading,
}) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      header={t('fai.submitWorkPromptTitle')}
      details={t('fai.submitWorkPromptBody')}
      buttons={[
        <ModalButton
          key="fai-submit-prompt-skip"
          variant="inferior"
          disabled={sendLoading}
          onClick={() => {
            return onSkip();
          }}
        >
          {t('fai.skipInspection')}
        </ModalButton>,
        <ModalButton
          key="fai-submit-prompt-send"
          customStyles={{
            backgroundColor: palette.Indigo600,
            color: palette.White,
          }}
          hoverStyles={{
            backgroundColor: palette.Indigo700,
          }}
          disabled={sendLoading}
          onClick={() => {
            return onSendForInspection();
          }}
        >
          {t('fai.sendForInspection')}
        </ModalButton>,
      ]}
    />
  );
};

FAISubmitWorkPromptModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  onSendForInspection: PropTypes.func.isRequired,
  sendLoading: PropTypes.bool,
};

FAISubmitWorkPromptModal.defaultProps = {
  sendLoading: false,
};

export { FAISubmitWorkPromptModal };
